import type { FormState } from './types';

/**
 * Whether the BOL on screen would print something other than what is saved.
 *
 * Deliberately narrower than the dialog's own dirty check: the BOL is built
 * from stored values, so it only cares about the fields that actually reach the
 * document, plus a staged carrier. It notably omits `loadOptionId`, which is
 * why the fulfilment-method reconciliation bug never affected this banner.
 */
export function isBOLDirty(form: FormState, initial: FormState): boolean {
  return (
    form.locationId !== initial.locationId ||
    form.driverName !== initial.driverName ||
    form.truckNumber !== initial.truckNumber ||
    form.pickupDate !== initial.pickupDate ||
    form.deliveryDate !== initial.deliveryDate ||
    form.pickupNote !== initial.pickupNote ||
    form.deliveryNote !== initial.deliveryNote ||
    form.deliveryAddressId !== initial.deliveryAddressId ||
    form.quantity !== initial.quantity ||
    form.pendingCarrierId !== undefined
  );
}
